<template>
  <div class="le">
    <!-- Sections des Live-Editor-Tabs — bewusst als Karten, damit hier künftig
         weitere Bereiche (Styles, Preise, …) andocken können -->
    <v-card class="le-card">
      <div class="le-card__head">
        <v-icon small class="le-card__icon">mdi-image-multiple-outline</v-icon>
        Theme-Vorschaubilder
      </div>
      <ThemePreviewsPanel />
    </v-card>
  </div>
</template>

<script>
import ThemePreviewsPanel from "@/components/Settings/ThemePreviews/ThemePreviewsPanel";

export default {
  name: "LiveEditorPanel",
  components: { ThemePreviewsPanel },
};
</script>

<style lang="scss" scoped>
.le {
  padding-bottom: 40px;
}

.le-card {
  border-radius: 14px !important;
  padding: 18px 20px 22px;

  &__head {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  &__icon {
    margin-right: 8px;
    color: #7b5cd6 !important;
  }
}
</style>
